import React from "react";
import { RMFlightWrapper, Mapper } from "../../../../types";
import CodeShareIcon from "../CodeShareIcon";

interface Props {
  result: RMFlightWrapper;
  mapper: Mapper;
}

function SearchFlightsResultRowSFO({ result }: Props) {
  return (
    <div className="column is-flex-direction-column is-mobile is-vcentered p-0 row-container">
      {result.arrival && (
        <div className="result-row py-0" role="row">
          <div className="column px-0 airline-column" role="cell">{result.airline}</div>
          <div className="column px-0" role="cell">{result.aircraft}</div>
          <div className="column px-0" role="cell">{result.depart}</div>
          <div className="column px-0" role="cell">
            {result.operatedBy}
            {result.flightNo}
            {result.codeshareInd && <CodeShareIcon />}
          </div>
          <div className="column px-0" role="cell">
            {result.connxLeg1Arrival != null
              ? result.connxLeg1Arrival
              : result.arrival}
          </div>
          <div className="column px-0" role="cell">{result.departureTimeAsString}</div>
          <div className="column px-0" role="cell">
            {result.connxLeg1ArrivalTimeAsString !== null
              ? result.connxLeg1ArrivalTimeAsString
              : result.arrivalTimeAsString}
          </div>
          <div className="column px-0 flight-stops" role="cell">{result.stops}</div>
          <div className="column px-0 total-flight-time" role="cell">
            {Math.floor(result.travelTime / 60)}hrs {result.travelTime % 60}mins
          </div>
        </div>
      )}
      {result.connxLeg2OperatedBy && (
        <div className="result-row py-0" role="row">
          <div className="column px-0 airline-column" role="cell">
            {result.connxLeg2Airline}
          </div>
          <div className="column px-0" role="cell">{result.connxLeg2Aircraft}</div>
          <div className="column px-0" role="cell">{result.connxLeg2Depart}</div>
          <div className="column px-0" role="cell">
            {result.connxLeg2OperatedBy}
            {result.connxLeg2FlightNo}
            {result.connxLeg2CodeshareInd && <CodeShareIcon />}
            {/* {mapper.enableLowCostIndicator &&	(result.lowCost || result.connxLeg2LowCost) && (<LowCostIcon />)} */}
          </div>
          <div className="column px-0" role="cell">{result.arrival}</div>
          <div className="column px-0" role="cell">
            {result.connxLeg2DepartureTimeAsString}
          </div>
          <div className="column px-0" role="cell">{result.arrivalTimeAsString}</div>
          <div className="column px-0 flight-stops" role="cell">
            {result.connxLeg2Stops}
          </div>
          <div className="column px-0 total-flight-time" role="cell">
            {Math.floor(result.connxLeg2TravelTime / 60)}hrs{" "}
            {result.connxLeg2TravelTime % 60}mins
          </div>
        </div>
      )}
      {result.connxLeg3OperatedBy && (
        <div className="result-row py-0" role="row">
          <div className="column px-0 airline-column" role="cell">
            {result.connxLeg3Airline}
          </div>
          <div className="column px-0" role="cell">{result.connxLeg3Aircraft}</div>
          <div className="column px-0" role="cell">{result.connxLeg3Depart}</div>
          <div className="column px-0" role="cell">
            {result.connxLeg3OperatedBy}
            {result.connxLeg3FlightNo}
            {result.connxLeg3CodeshareInd && <CodeShareIcon />}
          </div>
          <div className="column px-0" role="cell">{result.arrival}</div>
          <div className="column px-0" role="cell">
            {result.connxLeg3DepartureTimeAsString}
          </div>
          <div className="column px-0" role="cell">
            {result.connxLeg3ArrivalTimeAsString}
          </div>
          <div className="column px-0 flight-stops" role="cell">
            {result.connxLeg3Stops}
          </div>
          <div className="column px-0 total-flight-time" role="cell">
            {Math.floor(result.connxLeg3TravelTime / 60)}hrs{" "}
            {result.connxLeg3TravelTime % 60}mins
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchFlightsResultRowSFO;
